import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {Translate} from 'react-redux-i18n';

import {addError, addSuccess} from '../../../../actions/snackbars';

function InformationMessageWithActionsView(props) {
  const dispatch = useDispatch();

  const handleCancel = () => {
    props.onCancel()
      .then(() => {
        dispatch(addSuccess(<Translate value="message.changesSaved"/>));
        props.onRefresh();
      })
      .catch(() => {
        dispatch(addError(<Translate value="error.generic"/>));
      });
  };

  return (
    <div
      className='background-white p-3 mx-0 my-3 row justify-content-between align-items-center'
    >
      <span className='col-6'><Translate value={props.message}/></span>
      <div className='col-6 row justify-content-end'>
        <button
          type="button"
          className="large primary"
          onClick={props.onConfirm}
          data-id="confirm"
        >
          <Translate value={props.confirmMessage}/>
        </button>
        <button
          type="button"
          className="large secondary ml-5"
          onClick={handleCancel}
          data-id="cancel"
        >
          <Translate value={props.cancelMessage}/>
        </button>
      </div>
    </div>
  );
}

InformationMessageWithActionsView.propTypes = {
  message: PropTypes.string.isRequired,
  confirmMessage: PropTypes.string.isRequired,
  cancelMessage: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired
};

export default InformationMessageWithActionsView;
